var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('v-row',[_c('v-col',{class:{ 'pt-0': !_vm.isMdAndUp },attrs:{"cols":"12","md":"12","sm":"12"}},[_c('my-page-market-balance-list',{attrs:{"is-fetch-balance-list":_vm.isFetchBalanceList}})],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }